/**
 * @desc 根据出库单查询出库的sn码列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(dono: string | number, options?: any) {
  return updateResponse(
    http(URL + `/outMaster/getSnListByDono/${dono}`, {
      method: "GET",

      ...options,
    }),
  );
}
